import React from "react";
import { Fragment } from "react";
import curbsidePWAImage from "../../../../assets/images/ActionImages/curbSideIcon.png";
import pwaDelivery from "../../../../assets/images/ActionImages/deliverypwa.png";
import AllPwa from "../../../../assets/images/ActionImages/tickIcon.png";

const SubnavigatorMobilepwa = (props) => {
  var submenu = [
    {
      id: 11,
      title: "Pending",
      link: "",
      icon: require("../../../../assets/images/ActionImages/pendingPwa.png"),     
      show: true,
    },
    {
      id: 10,
      title: "All",
      link: "",
      icon: AllPwa,
      show: true,
    },
    {
      id: 0,
      title: "Take Away",
      link: "",
      icon: require("../../../../assets/images/ActionImages/Takeaway.png"),
      show: props.take_away,
    },
    {
      id: 1,
      title: "Curb Side",
      link: "",
      icon: curbsidePWAImage,
      show: props.curb_side,
    },
    {
      id: 2,
      title: "Skip-The Line",
      link: "",
      icon: require("../../../../assets/images/ActionImages/skipthelinePwa.png"),
      show: props.skip_line,
    },
    {
      id: 3,
      title: "Dine - In",
      link: "",
      icon: require("../../../../assets/images/ActionImages/pwaDineIn-img.png"),
      show: props.dine_in,
      //show: true,
    },
    {
      id: 7,
      title: "Delivery",
      link: "",
      icon: pwaDelivery,
      show: props.home_delivery,
    },
    {
      id: 20,
      title: "History",
      link: "",
      icon: require("../../../../assets/images/ActionImages/HistoryPwa.png"),
      show: true,
    },
  ];
  try {
    return (
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            // fontSize: ".75rem",
            margin: "0% 0% 2% 0%",
            // width:"133.33%"
            // flexDirection: "row",
            display: "flex",
            // flexWrap: "initial",
          }}
          className=" sub-menu-ordering"
        >
          {/* {console.log(props)} */}
          {submenu &&
            submenu.map((menudata, index) => {
              return (
                <Fragment key={index}>
                  {menudata.show ? (
                    <div
                      key={menudata.id}
                      align="center"
                      className="col-sm-3 col-lg-2 col-md-2 super-admin-sub-navigation-menu-orders"
                      onClick={
                        menudata.id === 11
                          ? props.onActionClick(11)
                          : menudata.id === 20
                          ? props.onActionClick(20)
                          : menudata.id === 10
                          ? props.onActionClick(10)
                          : menudata.id === 2
                          ? props.onActionClick(2)
                          : menudata.id === 0
                          ? props.onActionClick(0)
                          : menudata.id === 1
                          ? props.onActionClick(1)
                          : menudata.id === 4
                          ? props.onActionClick(4)
                          : menudata.id === 3
                          ? props.onActionClick(3)
                          : props.onActionClick(7)
                      }
                    >
                      <div
                        className={
                          (props.orderType === 11 && menudata.id === 11) ||
                          (props.orderType === 10 && menudata.id === 10) ||
                          (props.orderType === 0 && menudata.id === 0) ||
                          (props.orderType === 1 && menudata.id === 1) ||
                          (props.orderType === 4 && menudata.id === 4) ||
                          (props.orderType === 3 && menudata.id === 3) ||
                          (props.orderType === 2 && menudata.id === 2) ||
                          (props.orderType === 7 && menudata.id === 7) ||
                          (props.orderType === 20 && menudata.id === 20)
                            ? "submenu-icons sm-i-borderred"
                            : "submenu-icons sm-i-border"
                        }
                        style={{ cursor: "pointer" }}
                      >
                         <img
                          src={menudata.icon}
                          className="rounded-circle w-100"
                          alt={menudata.title}
                          title={menudata.title}
                
                        
                        /> 
                      </div>
                      <p
                        className={
                          (props.orderType === 11 && menudata.id === 11) ||
                          (props.orderType === 10 && menudata.id === 10) ||
                          (props.orderType === 0 && menudata.id === 0) ||
                          (props.orderType === 1 && menudata.id === 1) ||
                          (props.orderType === 2 && menudata.id === 2) ||
                          (props.orderType === 3 && menudata.id === 3) ||
                          (props.orderType === 4 && menudata.id === 4) ||
                          (props.orderType === 5 && menudata.id === 5) ||
                          (props.orderType === 7 && menudata.id === 7) ||
                          (props.orderType === 20 && menudata.id === 20)
                            ? "f14-700 text-red mt-2"
                            : "f12-500 mt-2"
                        }
                      >
                        {menudata.title}
                      </p>
                    </div>
                  ) : (
                    <Fragment> </Fragment>
                  )}
                </Fragment>
              );
            })}
        </div>
      </div>
    );
  } catch (e) {
    console.log(e);
  }
};

export default SubnavigatorMobilepwa;
